import { render, staticRenderFns } from "./OrganicStore.vue?vue&type=template&id=47dadbe0&scoped=true&"
import script from "./OrganicStore.vue?vue&type=script&lang=js&"
export * from "./OrganicStore.vue?vue&type=script&lang=js&"
import style0 from "./OrganicStore.vue?vue&type=style&index=0&id=47dadbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dadbe0",
  null
  
)

export default component.exports